import { serviceName } from '../resources/serviceConstants';
import { NOTIFICATIONS } from '../resources/endPoint';

export const getNotificationsDetails = (userPortalId) => {
  const url = `${NOTIFICATIONS}?userPortalId=${userPortalId}`;
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.COMMON_MS,
  };
};

export const UpdateNotification = ({ notificationId, readStatus, userPortalId }) => {
  const data = {
    notificationId: notificationId,
    readStatus: readStatus,
    userPortalId,
  };

  return {
    url: NOTIFICATIONS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.COMMON_MS,
  };
};
